"use client"

import { useState, useEffect, startTransition } from "react"
import { Outlet } from "react-router-dom"
import Sidebar from "../layout/sidebar/sidebar"
import LoginForm from "../pages/login/login"
import "../App.css"

const Layout = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    () => Boolean(localStorage.getItem("token")) || localStorage.getItem("isLoggedIn") === "true",
  )
  const [isLoading, setIsLoading] = useState(false)

  const syncLoginState = () => {
    const token = localStorage.getItem("token")
    const loggedInStatus = localStorage.getItem("isLoggedIn") === "true"
    const authenticated = Boolean(token) || loggedInStatus

    if (authenticated && token) {
      localStorage.setItem("isLoggedIn", "true")
    }

    if (!authenticated) {
      localStorage.removeItem("isLoggedIn")
    }

    startTransition(() => {
      setIsLoggedIn(authenticated)
      setIsLoading(false)
    })
  }

  useEffect(() => {
    syncLoginState()

    const onAuthChange = () => syncLoginState()
    window.addEventListener("auth:changed", onAuthChange)
    window.addEventListener("storage", onAuthChange)

    return () => {
      window.removeEventListener("auth:changed", onAuthChange)
      window.removeEventListener("storage", onAuthChange)
    }
  }, [])

  const handleLogin = () => {
    startTransition(() => {
      setIsLoggedIn(true)
      localStorage.setItem("isLoggedIn", "true")
    })
  }

  if (!isLoggedIn) {
    return (
      <div className="login-page">
        <LoginForm onLoginSuccess={handleLogin} />
      </div>
    )
  }

  return (
    <div className="mein">
      <Sidebar />
      <main className="main">
        <Outlet />
      </main>
    </div>
  )
}

export default Layout
